var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message__system animate__animated animate__fadeInUp animate__faster",class:{'is-pending': _vm.isPendingMessage}},[_vm._v("\n  "+_vm._s(_vm.messageContent)+"\n  "),(_vm.isPendingMessage)?_c('div',{staticClass:"message__system-content"},[_vm._v("\n    "+_vm._s(_vm.messageContent)+"\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }